import { fetchRequest } from './rest'

export function login(email: string, password: string) {
  return fetchRequest('/auth/affiliate/login', 'post', {
    identifier: email,
    mode: 'password',
    secret: password
  })
}

export function registerAffiliate() {
  return fetchRequest('/users/referral/affiliate/register', 'post')
}

export function forgotPassword(email: string) {
  return fetchRequest('/users/verifications/request-otp', 'post', {
    request_type: 'reset-password',
    destination: email
  })
}

export function resetPasswordOtp(email: string, otp: string) {
  return fetchRequest('/users/verifications/verify-otp', 'post', {
    otp,
    action: 'reset-password',
    identifier: email
  })
}

export function setNewPassword(
  email: string,
  password: string,
  resetToken: string
) {
  return fetchRequest(
    '/auth/reset-password',
    'patch',
    { email_address: email, password },
    { 'x-rise-authorization-token': resetToken }
  )
}

// Maturity date: earliest first. Date added: newest first.
export function getDetails({
  offset,
  limit,
  sortBy
}: {
  offset: number
  limit: number
  sortBy: CommissionSort
}) {
  return fetchRequest('/users/referral/affiliate/details', 'get', {
    offset,
    limit,
    order_by: sortBy,
    order: sortBy === 'maturity_date' ? 'asc' : 'desc'
  })
}
